<!-- To use a transparent background with this iframe, use <iframe src="stuff.htm" allowtransparency="true"></iframe> -->
@if (loaded() && !campaignInactive()) {
  <div class="wrapper" role="main" [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }">
    <div class="wrapper-bg" role="banner">
      <div class="header-wrapper">
        <div class="header-image-wrapper">
          <div
            class="header-img"
            style="
            background-image:url('{{ townshipImage() }}');
            "
          ></div>
        </div>
        <div class="header-text-button-wrapper">
          <h1 class="header-text">
            {{ townshipName() }}
          </h1>
          <div class="header-button-wrapper">
            <button (click)="setHighContrast()" mat-flat-button class="header-button">
              <mat-icon>contrast</mat-icon>
              Hoog contrast
            </button>
          </div>
        </div>
      </div>
    </div>
    <mat-stepper [linear]="true" #stepper>
      <mat-step [stepControl]="addressForm">
        <form class="address-form-wrapper" [formGroup]="addressForm" aria-label="zoeken op adres">
          <div role="group" aria-label="adres gegevens">
            <mat-form-field class="postal">
              <mat-label>{{ 'input.postal' | translate }}</mat-label>
              <input
                matInput
                formControlName="postal"
                autocomplete="postal-code"
                data-lpignore="true"
                placeholder="1234AB"
              />
              <mat-error>
                {{ getError(addressForm, 'postal') }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="house-number">
              <mat-label>{{ 'input.houseNumber' | translate }}</mat-label>
              <input
                matInput
                formControlName="houseNumber"
                autocomplete="address-line2"
                (keydown.space)="$event.preventDefault()"
                type="text"
                oninput="this.value = !!this.value && Math.abs(this.value) >= 1 ? Math.abs(this.value) : null"
                data-lpignore="true"
              />
              <mat-error>
                {{ getError(addressForm, 'houseNumber') }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="addition">
              <mat-label>
                {{ 'input.houseNumberAddition' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="houseNumberAddition"
                autocomplete="off"
                (keydown.space)="$event.preventDefault()"
                data-lpignore="true"
              />
              <mat-hint>Dit veld is optioneel</mat-hint>
              <mat-error>
                {{ getError(addressForm, 'houseNumberAddition') }}
              </mat-error>
            </mat-form-field>
          </div>
          @if (errorMessage()) {
            <div class="error-searching-address">
              {{ errorMessage() | translate }}
            </div>
          }
          <div class="stepper-buttons-wrapper">
            <div class="stepper-buttons">
              <div></div>
              <button
                mat-flat-button
                class="spinner-button"
                (click)="findVoucherGroups(null, null, null, true, true)"
                [disabled]="awaitingResponse()"
              >
                {{ 'find-voucher-group.body.next' | translate }}
                @if (awaitingResponse()) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      @if (interimAddressStepEnabled()) {
        <mat-step [stepControl]="interimAddressTypeForm">
          <form class="interim-address-type-form-wrapper" [formGroup]="interimAddressTypeForm">
            <div class="title" role="heading" aria-level="1">Aanvullende adresgegevens</div>
            <div class="interim-options-wrapper">
              @if (interimAddressTypes()?.required?.length > 0) {
                <div class="interim-options-subtitle">Mijn situatie is</div>
                <mat-radio-group class="interim-options" formControlName="livingSituation">
                  @for (type of interimAddressTypes()?.required; track type) {
                    <mat-radio-button class="interim-option" [value]="type.type">
                      {{ type.displayLabel }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              }
              @if (interimAddressTypes()?.optional?.length > 0) {
                <div class="interim-options-subtitle">Aanvullende kenmerken</div>
                <div class="interim-options">
                  @for (type of interimAddressTypes()?.optional; track type) {
                    <mat-checkbox class="interim-option" [formControlName]="type.type">
                      {{ type.displayLabel }}
                    </mat-checkbox>
                  }
                </div>
              }
            </div>
            <div class="stepper-buttons-wrapper">
              <div class="stepper-buttons">
                <button mat-button matStepperPrevious type="button">
                  <mat-icon>arrow_back</mat-icon>
                  {{ 'find-voucher-group.body.previous' | translate }}
                </button>
                <button
                  mat-flat-button
                  class="spinner-button"
                  (click)="setInterimAddressTypes()"
                  [disabled]="awaitingResponse() || !interimAddressTypeForm.valid"
                >
                  {{ 'find-voucher-group.body.next' | translate }}
                  @if (awaitingResponse()) {
                    <mat-spinner diameter="20"></mat-spinner>
                  }
                </button>
              </div>
            </div>
          </form>
        </mat-step>
      }
      @if (pinVerificationNeeded() && (!voucherGroups() || voucherGroups().length === 0)) {
        <mat-step [stepControl]="verificationForm">
          <form
            class="verification-form-wrapper"
            [formGroup]="verificationForm"
            (ngSubmit)="findVoucherGroups(verificationForm.controls.pin.value)"
            aria-label="verificatie met pincode"
          >
            <div class="title" role="heading" aria-level="1">Bekijk de opties op {{ addressString() }}</div>
            <div class="small-title-no-sub">
              Vul hier de pincode in die u heeft ontvangen. U kunt met deze pincode zien welke opties voor u beschikbaar
              zijn op uw adres.
            </div>
            <mat-form-field>
              <mat-label>Pincode</mat-label>
              <input
                cdkFocusInitial
                placeholder="1234"
                formControlName="pin"
                autocomplete="off"
                matInput
                (keydown.space)="$event.preventDefault()"
              />
              <mat-error>
                {{ getError(verificationForm, 'pin') }}
              </mat-error>
            </mat-form-field>
            <div class="custom-tooltip pin-info" tabindex="0" role="tabpanel" aria-label="pin info">
              Waar staat mijn pincode?
            </div>
            <div class="actions">
              <button mat-flat-button (click)="stepper.previous()" type="button">
                <mat-icon>arrow_back</mat-icon>
                {{ 'find-voucher-group.body.previous' | translate }}
              </button>
              <button
                mat-flat-button
                [disabled]="!verificationForm.valid || awaitingResponse()"
                [class.spinner]="awaitingResponse()"
              >
                Pincode bevestigen
              </button>
            </div>
          </form>
        </mat-step>
      }
      <mat-step [stepControl]="voucherGroupForm">
        @if (voucherGroups()) {
          <div class="voucher-groups-wrapper">
            <div class="title-wrapper">
              <div class="title" role="heading" aria-level="1">
                {{
                  noActions()
                    ? `Geen opties beschikbaar op uw adres: ${addressString()}`
                    : `Deze opties zijn beschikbaar op uw adres: ${addressString()}`
                }}
              </div>
              <!-- <div class="small-title">
                {{
                  noActions()
                    ? 'Er zijn helaas geen opties beschikbaar op uw adres: ' + addressString()
                    : 'Deze opties zijn beschikbaar op uw adres: ' + addressString()
                }}
              </div> -->
              @if (pinVerificationNeeded() && !noActions()) {
                <form
                  class="verification-form-wrapper"
                  [formGroup]="verificationForm"
                  (ngSubmit)="findVoucherGroups(verificationForm.controls.pin.value); $event.preventDefault()"
                  aria-label="verificatie met pincode"
                >
                  <div class="small-title">
                    Vul hier de pincode in die u heeft ontvangen. U kunt met deze pincode zien welke opties voor u
                    beschikbaar zijn op uw adres.
                  </div>
                  <mat-form-field>
                    <mat-label>Pincode</mat-label>
                    <input
                      cdkFocusInitial
                      placeholder="1234"
                      formControlName="pin"
                      autocomplete="off"
                      matInput
                      (keydown.space)="$event.preventDefault()"
                    />
                    <mat-error>
                      {{ getError(verificationForm, 'pin') }}
                    </mat-error>
                  </mat-form-field>
                  <div class="pin-info-wrapper">
                    <div class="custom-tooltip pin-info" tabindex="0" role="tabpanel" aria-label="pin info">
                      Waar staat mijn pincode?
                    </div>
                    <button
                      mat-flat-button
                      [disabled]="!verificationForm.valid || awaitingResponse()"
                      [class.spinner]="awaitingResponse()"
                    >
                      Pincode verifiëren
                    </button>
                  </div>
                </form>
              }
              <div class="small-title">
                {{ !noActions() && groupLinks()?.length > 0 ? 'Kies een optie voor meer informatie' : '' }}
              </div>
            </div>
            @for (groupLinkFor of groupLinks(); track groupLinkFor) {
              <div class="group-links-wrapper">
                <div class="group-link-title">{{ groupLinkFor.text }}</div>
                <div class="voucher-group-cards-wrapper">
                  @for (voucherGroup of groupLinkFor.voucherGroups; track voucherGroup; let i2 = $index) {
                    <div class="voucher-group-card-wrapper">
                      <div
                        matRipple
                        [matRippleColor]="'rgba(0,0,0,0.18)'"
                        [matRippleDisabled]="infoButtonActive()"
                        class="voucher-group-card"
                        tabindex="0"
                        role="tabpanel"
                        [title]="voucherGroup.name"
                        (click)="
                          voucherGroup.infoButtonUrl
                            ? openInfoButtonUrl(voucherGroup.infoButtonUrl)
                            : selectVoucherGroup(voucherGroup)
                        "
                        (keyup.enter)="
                          voucherGroup.infoButtonUrl
                            ? openInfoButtonUrl(voucherGroup.infoButtonUrl)
                            : selectVoucherGroup(voucherGroup)
                        "
                      >
                        @if (voucherGroup.imageUrl) {
                          <div class="avatar" style="background-image:url('{{ voucherGroup.imageUrl }}');"></div>
                        }
                        @if (!voucherGroup.imageUrl) {
                          <div class="avatar placeholder">
                            {{ voucherGroup.name[0] }}
                          </div>
                        }
                        <div class="card-content">
                          <div class="title-slogan">
                            <div class="title">
                              {{ voucherGroup.name }}
                            </div>
                            @if (voucherGroup.slogan) {
                              <div class="slogan">
                                {{ voucherGroup.slogan }}
                              </div>
                            }
                          </div>
                          <div class="voucher-content-wrapper">
                            <div class="voucher-value-wrapper">
                              @if (voucherGroup.couponValue && !voucherGroup.altTextCouponValue) {
                                <div class="voucher-value">€{{ getCurrencyString(voucherGroup.couponValue) }}</div>
                              }
                              @if (!voucherGroup.altTextCouponValue) {
                                <div class="coupon">
                                  {{ 'find-voucher-group.body.voucher' | translate }}
                                </div>
                              }
                              @if (voucherGroup.altTextCouponValue) {
                                <div class="alt-coupon">
                                  {{ voucherGroup.altTextCouponValue }}
                                </div>
                              }
                            </div>
                            @if (voucherGroup.infoButtonText && voucherGroup.infoButtonUrl) {
                              <div class="info-button">
                                <a
                                  mat-flat-button
                                  class="primary-color"
                                  href="{{ voucherGroup.infoButtonUrl }}"
                                  target="_blank"
                                  [attr.aria-label]="'meer informatie over ' + voucherGroup.name"
                                  (click)="$event.stopPropagation()"
                                  (keyup.enter)="$event.stopPropagation()"
                                  (mouseenter)="infoButtonActive.set(true)"
                                  (focus)="infoButtonActive.set(true)"
                                  (mouseleave)="infoButtonActive.set(false)"
                                  (blur)="infoButtonActive.set(false)"
                                  tabindex="-1"
                                >
                                  {{ voucherGroup.infoButtonText }}
                                </a>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (
                        groupLinkFor.voucherGroups.length > 1 &&
                        i2 < groupLinkFor.voucherGroups.length - 1 &&
                        !groupLinkFor.hideDivider
                      ) {
                        <div class="separator">
                          <div class="text">- {{ 'find-voucher-group.body.or' | translate }} -</div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div class="stepper-buttons-wrapper">
              <div class="stepper-buttons">
                <button mat-button matStepperPrevious type="button">
                  <mat-icon>arrow_back</mat-icon>
                  {{ 'find-voucher-group.body.previous' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </mat-step>
      <mat-step [stepControl]="termsForm">
        @if (voucherGroupForm.value.voucherGroup; as voucherGroup) {
          <div class="voucher-group-details">
            <div class="top-title" role="heading" aria-level="1">
              {{ voucherGroup.name }}
            </div>
            <div class="small-top-title">
              {{ addressString() }}
            </div>
            @if (voucherGroup.imageUrl) {
              <div class="avatar large image" style="background-image:url('{{ voucherGroup.imageUrl }}');"></div>
            }
            @if (!voucherGroup.imageUrl) {
              <div class="avatar large placeholder">
                {{ voucherGroup.name[0] }}
              </div>
            }
            <div class="title-slogan-desc">
              @if (voucherGroup.slogan) {
                <h3 class="slogan">
                  {{ voucherGroup.slogan }}
                </h3>
              }
              @if (voucherGroup.description) {
                <div class="description">
                  {{ voucherGroup.description }}
                </div>
              }
            </div>
            <div class="terms">
              <h3 class="title">
                {{ 'find-voucher-group.body.terms_group' | translate }}
              </h3>
              @if (voucherGroup.terms) {
                <div class="voucher-group-terms">
                  {{ voucherGroup.terms }}
                </div>
              }
              <div class="title">{{ 'terms.heading' | translate }}</div>
              <a class="terms-link" [href]="termsUrl()" target="_blank" rel="noopener noreferrer">
                {{ 'terms.general' | translate }}
              </a>
              <a class="terms-link" [href]="privacyUrl()" target="_blank" rel="noopener noreferrer">
                {{ 'terms.privacy' | translate }}
              </a>
            </div>
            <form [formGroup]="termsForm" aria-label="voorwaarden checkbox">
              <mat-checkbox class="terms-checkbox" formControlName="acceptTerms">
                {{ 'find-voucher-group.body.terms_accept' | translate }}
              </mat-checkbox>
            </form>
            <div class="stepper-buttons-wrapper">
              <div class="stepper-buttons">
                <button mat-button matStepperPrevious (click)="termsForm.reset()">
                  {{ 'find-voucher-group.body.previous' | translate }}
                </button>
                <button mat-flat-button (click)="generateActivateVoucherStep()" [disabled]="!termsForm.valid">
                  {{ 'find-voucher-group.body.next' | translate }}
                </button>
              </div>
            </div>
          </div>
        }
      </mat-step>
      <mat-step>
        <div class="activate-step">
          <div class="activate-title-wrapper">
            <div class="title" role="heading" aria-level="1">Uw gegevens</div>
            <div class="small-title-no-sub">
              Vul hier uw gegevens in om uw aanvraag voor {{ addressString() }} in te dienen
            </div>
          </div>
          @if (activateVoucherComponentData) {
            <app-activate-voucher [inputData]="activateVoucherComponentData"></app-activate-voucher>
          }
          <div class="floating-back-button-wrapper">
            <div class="floating-back-button">
              <button mat-button matStepperPrevious (click)="activateVoucherComponentData = null">
                {{ 'find-voucher-group.body.previous' | translate }}
              </button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
} @else if (campaignInactive()) {
  <div class="wrapper" role="main" [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }">
    <div class="wrapper-bg" role="banner">
      <div class="header-wrapper">
        <div class="header-image-wrapper">
          <div class="header-img" style="background-image:url('{{ townshipImage() }}')"></div>
        </div>
        <div class="header-text-button-wrapper">
          <h1 class="header-text">{{ townshipName() }}</h1>
          <div class="header-button-wrapper">
            <button (click)="setHighContrast()" mat-flat-button class="header-button">
              <mat-icon>contrast</mat-icon>
              Hoog contrast
            </button>
          </div>
        </div>
      </div>
    </div>
    <p class="inactive-title">
      Het aanvragen en activeren van bonnen is niet meer mogelijk omdat deze campagne niet actief is.
    </p>
  </div>
} @else {
  <div class="loading-wrapper">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
